import classNames from 'classnames';
import { MouseEventHandler } from 'react';
import { Button } from 'yoso';
import { Tabs } from '~/components/Tab/Tabs';
import styles from './MarketplaceExplorerTabs.module.scss';

export type MarketplaceExplorerTabsProps = {
  value: string;
  className?: string;
  onChange?: MouseEventHandler;
};
export const MarketplaceExplorerTabs = ({
  value,
  className,
  onChange,
}: MarketplaceExplorerTabsProps) => (
  <Tabs className={classNames(styles.root, className)}>
    <li>
      <Button
        className={classNames(styles.tab, { [styles.active]: value === '' })}
        value=""
        onClick={onChange}>
        All
      </Button>
    </li>
    <li>
      <Button
        className={classNames(styles.tab, { [styles.active]: value === 'CITIZEN' })}
        value="CITIZEN"
        onClick={onChange}>
        Citizen
      </Button>
    </li>
    <li>
      <Button
        className={classNames(styles.tab, { [styles.active]: value === 'PET' })}
        value="PET"
        onClick={onChange}>
        Friends
      </Button>
    </li>
  </Tabs>
);
